<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="configurationMain">
          <project-asset v-on:project-changed="onProjectChange" v-on:vessel-changed="onVesselChange"></project-asset>
          <v-card id="configurationCard">
            <v-card-title id="tableTitle" class="primary--text" style="font-size: 1.5em; padding: 20px">{{ $t("nav.configMaster") }}</v-card-title>
            <v-data-table id="configurationTable" :headers="headers" :items="items" :items-per-page="-1" class="elevation-0">
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">{{ props.item.configurationID }}</td>
                  <td style="text-align: left">{{ props.item.projectName }}</td>
                  <td style="text-align: left">{{ props.item.vesselName }}</td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: left">{{ props.item.configType }}</td>
                  <!--  <td style="text-align: left">
                    <span v-if="props.item.dateFrom != null">
                      {{ dateMixin(props.item.dateFrom) }}
                    </span>
                  </td>
                  <td style="text-align: left">
                    <span v-if="props.item.dateTo != null">
                      {{ dateMixin(props.item.dateTo) }}
                    </span>
                  </td> -->
                  <td style="text-align: left">{{ props.item.stingerLength | formatTNumber }}</td>
                  <td style="text-align: left">{{ props.item.nozzleDiameters | formatTNumber }}</td>
                  <td style="text-align: left">{{ props.item.nozzleNo }}</td>
                  <td style="text-align: left">{{ props.item.maxPullingForce }}</td>
                  <td style="text-align: center">
                    <v-btn id="btnDel" color="primary" x-small fab outlined elevation="1" @click="deleteItemConfirm(props.item)"> <v-icon small color="primary">mdi-delete</v-icon> </v-btn>&nbsp;
                    <v-btn id="btnEdit" color="primary" x-small fab outlined elevation="1" :disabled="props.item.isDeleted === true" @click="editItem(props.item)">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="65%">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field v-model="editedItem.configurationID" :rules="[() => !!editedItem.configurationID || requiredMessage]" required>
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("nav.configMasterId") }}
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="3" md="3">
                          <v-select :rules="[() => !!editedItem.projectId || requiredMessage]" required :items="projects" item-text="Name" item-value="Id" v-model="editedItem.projectId" :readonly="editedIndex != -1" @change="onDlgProjectChange">
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("common.projectName") }}
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-select :rules="[() => !!editedItem.vesselId || requiredMessage]" required class="form-control" :items="projectVessels" item-text="Name" item-value="Id" v-model="editedItem.vesselId" :readonly="editedIndex != -1" @change="onDlgVesselChange">
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("common.asset") }}
                            </template>
                          </v-select>
                        </v-col>
                        <!--  <v-col cols="12" sm="3" md="3">
                          <date-input v-model="editedItem.dateFrom" :min="minDateFrom" label="From"></date-input>
                        </v-col>

                        <v-col cols="12" sm="3" md="3">
                          <date-input v-model="editedItem.dateTo" :min="minDateTo" label="To"></date-input>
                        </v-col> -->
                        <v-col cols="12" sm="9" md="9">
                          <v-text-field v-model="editedItem.description" :rules="[() => !!editedItem.description || requiredMessage]" required>
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t("column.description") }}
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <v-text-field v-model="editedItem.configType">
                            <template v-slot:label>{{ $t("configMaster.configType") }}</template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.stingerLength" label="configMaster.stingerLength" thousands-separator decimals :no-decimals="2"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.nozzleDiameters" label="configMaster.nozzleDiameters" thousands-separator decimals :no-decimals="2"></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.nozzleNo" label="configMaster.nozzleNo" thousands-separator></positive-numeric-input>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                          <positive-numeric-input v-model="editedItem.maxPullingForce" label="configMaster.maxPullingForce" thousands-separator decimals :no-decimals="2"></positive-numeric-input>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">
                    {{ $t("common.cancel") }}
                  </v-btn>
                  <v-btn color="primary" text @click="save" :disabled="!formIsValid">{{ $t("common.save") }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-fab-transition>
                <v-btn id="btnAddconfiguration" color="primary" dark small left fab @click="createItem()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import ProjectAsset from "../common/ProjectAsset";

export default {
  components: {
    "project-asset": ProjectAsset,
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      date1: this.date1 >= new Date().toISOString().substr(0, 10),
      menu: false,
      menu1: false,

      dialog: false,
      requiredMessage: this.$t("common.required"),
      headers: [
        {
          text: this.$t("nav.configMasterId"),
          align: "left",
          sortable: true,
          value: "configurationID",
          width: "15%",
        },
        {
          text: this.$t("common.projectName"),
          align: "left",
          value: "projectId",
        },
        {
          text: this.$t("common.asset"),
          align: "left",
          value: "vesselId",
        },
        {
          text: this.$t("column.description"),
          align: "left",
          value: "description",
        },
        {
          text: this.$t("configMaster.configType"),
          align: "left",
          value: "configType",
        },
        /*  {
          text: this.$t("configMaster.dateFrom"),
          align: "left",
          value: "dateFrom",
        },
        {
          text: this.$t("configMaster.dateTo"),
          align: "left",
          value: "dateTo",
        }, */
        {
          text: this.$t("configMaster.stingerLength"),
          align: "left",
          value: "stingerLength",
        },
        {
          text: this.$t("configMaster.nozzleDiameters"),
          align: "left",
          value: "nozzleDiameters",
        },
        {
          text: this.$t("configMaster.nozzleNo"),
          align: "left",
          value: "nozzleNo",
        },
        {
          text: this.$t("configMaster.maxPullingForce"),
          align: "left",
          value: "maxPullingForce",
        },
        {
          text: this.$t("column.actions"),
          align: "center",
          value: "opactions",
          sortable: false,
          width: "20%",
        },
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},

      selProjectId: 0,
      selVesselId: 0,
      dlgSelProjectId: null,
    };
  },
  computed: {
    ...mapGetters(["m_configuration/getNextSeqCode", "m_configuration/getConfigurations", "m_project/getProjectNames", "m_project/getProjectVesselIds", "m_vessel/getVesselNames", "m_passet/getSelProjectId", "m_passet/getSelVesselId", "m_passet/getSelProjectVesselIds"]),

    minDateFrom() {
      return new Date().toISOString().slice(0, 10);
    },

    minDateTo() {
      return this.editedItem.dateFrom ? this.editedItem.dateFrom : new Date().toISOString().slice(0, 10);
    },

    formTitle() {
      return this.editedIndex === -1 ? this.$t("common.new") + " " + this.$t("nav.configMaster") : this.$t("common.edit") + " " + this.$t("nav.configMaster");
    },

    items() {
      return this["m_configuration/getConfigurations"];
    },

    projects() {
      return this["m_project/getProjectNames"].filter((p) => p.VCount > 0);
    },

    vessels() {
      return this["m_vessel/getVesselNames"];
    },

    projectVessels() {
      let vessels = this.vessels;

      let pvIds = this["m_passet/getSelProjectVesselIds"];
      if (this.dlgSelProjectId) {
        pvIds = this["m_project/getProjectVesselIds"];
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1);
    },

    formIsValid() {
      return this.editedItem.configurationID && this.editedItem.description && this.editedItem.projectId && this.editedItem.vesselId;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.selProjectId = this["m_passet/getSelProjectId"];
    this.selVesselId = this["m_passet/getSelVesselId"];

    this.$log.debug("loading configurations for", this.selProjectId, this.selVesselId);

    this.$log.debug("loading configurations for", this.selProjectId, this.selVesselId);
    this.refreshConfigurations();
    this.refreshNextSeqCode();
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },

  methods: {
    ...mapActions(["m_configuration/createConfiguration", "m_configuration/fetchConfigurations", "m_configuration/fetchNextMaxCode", "m_configuration/deleteConfiguration", "m_configuration/updateConfiguration", "m_project/fetchProjectVesselNames"]),
    ...mapMutations(["mHideLongLoader"]),

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },

    disablePastDates(val) {
      return val > new Date().toISOString().substr(0, 10);
    },

    refreshConfigurations() {
      this["m_configuration/fetchConfigurations"]({
        pId: this.selProjectId,
        vId: this.selVesselId,
      });
    },

    onProjectChange(value) {
      this.selProjectId = value;
      this.refreshConfigurations();
    },

    onVesselChange(value) {
      this.selVesselId = value;
      this.refreshConfigurations();
    },

    onDlgProjectChange() {
      this.dlgSelProjectId = this.editedItem.projectId;
      this.$log.debug("dlg project change", this.dlgSelProjectId);

      this["m_project/fetchProjectVesselNames"](this.dlgSelProjectId);
      this.refreshNextSeqCode();
    },

    onDlgVesselChange() {
      this.$log.debug("dlg vessel changed", this.editedItem.vesselId);
      if (!this.editedItem.projectId || !this.editedItem.vesselId) {
        return;
      }

      this.refreshNextSeqCode();
    },

    refreshNextSeqCode(useDefVal) {
      if (this.editedIndex > -1) {
        return false;
      }

      let pId = useDefVal ? this.selProjectId : this.editedItem.projectId;
      let vId = useDefVal ? this.selVesselId : this.editedItem.vesselId;

      this["m_configuration/fetchNextMaxCode"]({
        pId: pId,
        vId: vId,
      }).then((nextCode) => {
        this.editedItem.configurationID = nextCode;
        this.$nextTick(() => this.$forceUpdate());
      });
    },

    resetEntity(item) {
      this.dlgSelProjectId = null;
      this["m_project/fetchProjectVesselNames"](this.dlgSelProjectId);

      this.defaultItem.projectId = this["m_passet/getSelProjectId"];
      this.defaultItem.vesselId = this["m_passet/getSelVesselId"];

      this.editedIndex = item ? this.items.indexOf(item) : -1;
      this.editedItem = Object.assign({}, item || this.defaultItem);
    },

    editItem(item) {
      this.resetEntity(item);
      this.onDlgProjectChange();
      this.dialog = true;
    },

    createItem() {
      this.resetEntity();

      if (this.defaultItem.projectId != null && this.defaultItem.selVesselId) {
        this.onDlgVesselChange();
      }

      this.refreshNextSeqCode();
      this.editedItem.configurationID = this["m_configuration/getNextSeqCode"];
      this.dialog = true;
    },

    deleteItemConfirm(item) {
      this.resetEntity(item);

      var msg = this.editedItem.isDeleted ? "warming.unlock" : "warming.lock";

      this.$confirm(this.$t(msg) + this.$t("nav.configMaster") + "?", {
        buttonTrueText: this.$t("common.ok"),
        buttonFalseText: this.$t("common.cancel"),
        color: "warning",
        icon: "warning",
        title: this.$t("common.warning"),
        width: 350,
        property: "$confirm",
      }).then((res) => res && this["m_configuration/deleteConfiguration"](this.editedItem).then(this.refreshConfigurations));
    },

    close() {
      this.$refs.form.resetValidation();
      this.dialog = false;
    },

    save() {
      if (~this.editedIndex) {
        this["m_configuration/updateConfiguration"](this.editedItem).then(this.refreshConfigurations);
      }

      if (!~this.editedIndex) {
        this["m_configuration/createConfiguration"](this.editedItem).then(this.refreshConfigurations);
      }

      this.close();
    },
  },
};
</script>

<style>
#configurationsTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#configurationsTable header {
  font-weight: bold;
}
#configurationsCard {
  width: auto;
}
</style>
